import gql from 'graphql-tag';

// SAVE TRIBE
export const save = gql`
  mutation saveTribe($input: TribeDtoInput) {
    saveTribe(tribeDto: $input) {
      code
      status
      data {
        id
        name
      }
    }
  }
`;

// GET ALL TRIBE
export const get = gql`
  query getAllTribeList {
    getAllTribeList {
      code
      status
      data {
        id
        name
      }
    }
  }
`;

// DELETE TRIBE
export const remove = gql`
  mutation deleteTribe($input: String) {
    deleteTribe(tribeId: $input) {
      code
      status
      data {
        id
        name
      }
    }
  }
`;

// SEARCH TRIBE
export const search = gql`
  query searchTribe($input: String) {
    searchTribe(tribeName: $input) {
      code
      status
      data {
        id
        name
      }
    }
  }
`;
